<template>
  <!-- 304156   bfcbd9-->
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :default-openeds="defaultOpeneds"
      background-color="#f5f6fa"
      text-color="#000000"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes">
      </sidebar-item>
    </el-menu>
  </scroll-bar>
</template>
<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    defaultOpeneds() {
      const openPaths = [];
      const collect = (routes, parentPath = '') => {
        routes.forEach(route => {
          // 如果路由有 children 且不隐藏，并且不是单子菜单折叠的情况，则判定为父级菜单（el-submenu）
          if (route.children && route.children.length > 0 && !route.hidden) {
            // 对于父级菜单，其 index 为 route.name || route.path
            const index = route.name || route.path;
            if (route.meta && route.meta.defaultOpened === true) {
              openPaths.push(index);
            }
            // 继续遍历子路由，但注意如果子路由是单子菜单且没有 alwaysShow，则可能不会显示为子菜单，但我们这里只收集父级，所以不需要继续收集子级
            // 但为了安全性，可以继续收集嵌套子菜单
            if (route.children) {
              collect(route.children, index);
            }
          }
        });
      };
      collect(this.routes || []);
      return openPaths;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue